/*** IMPORTS FROM imports-loader ***/
(function() {

/* global Vue */
/* global dateFormat */

Vue.filter('due-date', (value) => {
  const date = new Date(value);
  return dateFormat(date, 'mmm d, yyyy', true);
});

}.call(window));


// WEBPACK FOOTER //
// ./boards/filters/due_date_filters.js.es6